<h6 id="table_progettoLeggiProgetto">Elenco atti di finanziamento</h6>
<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_progettoLeggiProgetto">
        <thead class="thead-light">
            <tr>
                <th scope="col">Atto di finanziamento</th>
                <th scope="col">Importo finanziamento (€)</th>
                <th scope="col">Anno finanziamento </th>
                <th scope="col">Programma</th>
                <th scope="col">Anno fine lavori</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items; let i = index">
                <td>{{ item.idLegge | anagraficaLegge : (datalist.legge || []) }}</td>
                <td>{{ item.importoFinanziatoEuro | currency : 'EUR':'':'.2-2':'it-IT' }}</td>
                <td>{{ item.annoFinanziamento }}</td>
                <td>{{ item.programma }}</td>
                <td>{{ item.annoFineLavori }}</td>
                <td class="actions">
                    <button aria-label="visualizza dettagli" type="button" class="btn btn-xs btn-link" container="body" ngbTooltip="Visualizza dettaglio" (click)="viewItem(item)">
                        <app-toolkit-bl-icon icon="search" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="modifica" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" ngbTooltip="Modifica" (click)="editItem(item)">
                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="elimina" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" ngbTooltip="Elimina" (click)="deleteItem(item.idLeggeProgetto)">
                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="!items.length">
                <td colspan="6"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="canEdit" class="button-actions">
    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Aggiungi
    </button>
</div>